import { releaseProxy, wrap } from 'comlink';
import type { WebWorker } from 'workers';

export type WorkerAPI = {
  workerApi: WebWorker;
  cleanup: () => void;
};

let workerApiAndCleanup: WorkerAPI | undefined;

/**
 * Creates a worker, a cleanup function and returns it
 */
export function callWorkerWithCleanup(): WorkerAPI {
  const createWoker = () => {
    // Here we create our worker and wrap it with comlink so we can interact with it
    const worker = new Worker(new URL('workers', import.meta.url), {
      name: 'rkt-worker',
      type: 'module',
    });

    const workerApi = wrap<import('workers').WebWorker>(worker);

    // A cleanup function that releases the comlink proxy and terminates the worker
    const cleanup = () => {
      worker.terminate();
      workerApi[releaseProxy](); // This is Comlink's method to release the proxy
    };

    return { workerApi, cleanup };
  };

  if (!workerApiAndCleanup) {
    workerApiAndCleanup = createWoker();
  }

  return workerApiAndCleanup;
}
